"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GeometryLayout = _interopRequireDefault(require("./GeometryLayout.js"));

var _GeometryType = _interopRequireDefault(require("./GeometryType.js"));

var _MultiPoint = _interopRequireDefault(require("./MultiPoint.js"));

var _Polygon = _interopRequireDefault(require("./Polygon.js"));

var _SimpleGeometry = _interopRequireDefault(require("./SimpleGeometry.js"));

var _closest = require("./flat/closest.js");

var _extent = require("../extent.js");

var _deflate = require("./flat/deflate.js");

var _array = require("../array.js");

var _interiorpoint = require("./flat/interiorpoint.js");

var _inflate = require("./flat/inflate.js");

var _intersectsextent = require("./flat/intersectsextent.js");

var _orient = require("./flat/orient.js");

var _area = require("./flat/area.js");

var _center = require("./flat/center.js");

var _contains = require("./flat/contains.js");

var _simplify = require("./flat/simplify.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/geom/MultiPolygon
 */


/**
 * @classdesc
 * Multi-polygon geometry.
 *
 * @api
 */
var MultiPolygon =
/** @class */
function (_super) {
  __extends(MultiPolygon, _super);
  /**
   * @param {Array<Array<Array<import("../coordinate.js").Coordinate>>|Polygon>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `opt_layout` and `opt_endss` are also accepted.
   * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
   * @param {Array<Array<number>>} [opt_endss] Array of ends for internal use with flat coordinates.
   */


  function MultiPolygon(coordinates, opt_layout, opt_endss) {
    var _this = _super.call(this) || this;
    /**
     * @type {Array<Array<number>>}
     * @private
     */


    _this.endss_ = [];
    /**
     * @private
     * @type {number}
     */

    _this.flatInteriorPointsRevision_ = -1;
    /**
     * @private
     * @type {Array<number>}
     */

    _this.flatInteriorPoints_ = null;
    /**
     * @private
     * @type {number}
     */

    _this.maxDelta_ = -1;
    /**
     * @private
     * @type {number}
     */

    _this.maxDeltaRevision_ = -1;
    /**
     * @private
     * @type {number}
     */

    _this.orientedRevision_ = -1;
    /**
     * @private
     * @type {Array<number>}
     */

    _this.orientedFlatCoordinates_ = null;

    if (!opt_endss && !Array.isArray(coordinates[0])) {
      var layout = _this.getLayout();

      var polygons =
      /** @type {Array<Polygon>} */
      coordinates;
      var flatCoordinates = [];
      var endss = [];

      for (var i = 0, ii = polygons.length; i < ii; ++i) {
        var polygon = polygons[i];

        if (i === 0) {
          layout = polygon.getLayout();
        }

        var offset = flatCoordinates.length;
        var ends = polygon.getEnds();

        for (var j = 0, jj = ends.length; j < jj; ++j) {
          ends[j] += offset;
        }

        (0, _array.extend)(flatCoordinates, polygon.getFlatCoordinates());
        endss.push(ends);
      }

      opt_layout = layout;
      coordinates = flatCoordinates;
      opt_endss = endss;
    }

    if (opt_layout !== undefined && opt_endss) {
      _this.setFlatCoordinates(opt_layout,
      /** @type {Array<number>} */
      coordinates);

      _this.endss_ = opt_endss;
    } else {
      _this.setCoordinates(
      /** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */
      coordinates, opt_layout);
    }

    return _this;
  }
  /**
   * Append the passed polygon to this multipolygon.
   * @param {Polygon} polygon Polygon.
   * @api
   */


  MultiPolygon.prototype.appendPolygon = function (polygon) {
    /** @type {Array<number>} */
    var ends;

    if (!this.flatCoordinates) {
      this.flatCoordinates = polygon.getFlatCoordinates().slice();
      ends = polygon.getEnds().slice();
      this.endss_.push();
    } else {
      var offset = this.flatCoordinates.length;
      (0, _array.extend)(this.flatCoordinates, polygon.getFlatCoordinates());
      ends = polygon.getEnds().slice();

      for (var i = 0, ii = ends.length; i < ii; ++i) {
        ends[i] += offset;
      }
    }

    this.endss_.push(ends);
    this.changed();
  };
  /**
   * Make a complete copy of the geometry.
   * @return {!MultiPolygon} Clone.
   * @api
   */


  MultiPolygon.prototype.clone = function () {
    var len = this.endss_.length;
    var newEndss = new Array(len);

    for (var i = 0; i < len; ++i) {
      newEndss[i] = this.endss_[i].slice();
    }

    var multiPolygon = new MultiPolygon(this.flatCoordinates.slice(), this.layout, newEndss);
    multiPolygon.applyProperties(this);
    return multiPolygon;
  };
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */


  MultiPolygon.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
    if (minSquaredDistance < (0, _extent.closestSquaredDistanceXY)(this.getExtent(), x, y)) {
      return minSquaredDistance;
    }

    if (this.maxDeltaRevision_ != this.getRevision()) {
      this.maxDelta_ = Math.sqrt((0, _closest.multiArrayMaxSquaredDelta)(this.flatCoordinates, 0, this.endss_, this.stride, 0));
      this.maxDeltaRevision_ = this.getRevision();
    }

    return (0, _closest.assignClosestMultiArrayPoint)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
  };
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */


  MultiPolygon.prototype.containsXY = function (x, y) {
    return (0, _contains.linearRingssContainsXY)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, x, y);
  };
  /**
   * Return the area of the multipolygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */


  MultiPolygon.prototype.getArea = function () {
    return (0, _area.linearRingss)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride);
  };
  /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for multi-polygons.
   *
   * @param {boolean} [opt_right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
   * @api
   */


  MultiPolygon.prototype.getCoordinates = function (opt_right) {
    var flatCoordinates;

    if (opt_right !== undefined) {
      flatCoordinates = this.getOrientedFlatCoordinates().slice();
      (0, _orient.orientLinearRingsArray)(flatCoordinates, 0, this.endss_, this.stride, opt_right);
    } else {
      flatCoordinates = this.flatCoordinates;
    }

    return (0, _inflate.inflateMultiCoordinatesArray)(flatCoordinates, 0, this.endss_, this.stride);
  };
  /**
   * @return {Array<Array<number>>} Endss.
   */


  MultiPolygon.prototype.getEndss = function () {
    return this.endss_;
  };
  /**
   * @return {Array<number>} Flat interior points.
   */


  MultiPolygon.prototype.getFlatInteriorPoints = function () {
    if (this.flatInteriorPointsRevision_ != this.getRevision()) {
      var flatCenters = (0, _center.linearRingss)(this.flatCoordinates, 0, this.endss_, this.stride);
      this.flatInteriorPoints_ = (0, _interiorpoint.getInteriorPointsOfMultiArray)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, flatCenters);
      this.flatInteriorPointsRevision_ = this.getRevision();
    }

    return this.flatInteriorPoints_;
  };
  /**
   * Return the interior points as {@link module:ol/geom/MultiPoint~MultiPoint multipoint}.
   * @return {MultiPoint} Interior points as XYM coordinates, where M is
   * the length of the horizontal intersection that the point belongs to.
   * @api
   */


  MultiPolygon.prototype.getInteriorPoints = function () {
    return new _MultiPoint["default"](this.getFlatInteriorPoints().slice(), _GeometryLayout["default"].XYM);
  };
  /**
   * @return {Array<number>} Oriented flat coordinates.
   */


  MultiPolygon.prototype.getOrientedFlatCoordinates = function () {
    if (this.orientedRevision_ != this.getRevision()) {
      var flatCoordinates = this.flatCoordinates;

      if ((0, _orient.linearRingssAreOriented)(flatCoordinates, 0, this.endss_, this.stride)) {
        this.orientedFlatCoordinates_ = flatCoordinates;
      } else {
        this.orientedFlatCoordinates_ = flatCoordinates.slice();
        this.orientedFlatCoordinates_.length = (0, _orient.orientLinearRingsArray)(this.orientedFlatCoordinates_, 0, this.endss_, this.stride);
      }

      this.orientedRevision_ = this.getRevision();
    }

    return this.orientedFlatCoordinates_;
  };
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiPolygon} Simplified MultiPolygon.
   * @protected
   */


  MultiPolygon.prototype.getSimplifiedGeometryInternal = function (squaredTolerance) {
    var simplifiedFlatCoordinates = [];
    var simplifiedEndss = [];
    simplifiedFlatCoordinates.length = (0, _simplify.quantizeMultiArray)(this.flatCoordinates, 0, this.endss_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEndss);
    return new MultiPolygon(simplifiedFlatCoordinates, _GeometryLayout["default"].XY, simplifiedEndss);
  };
  /**
   * Return the polygon at the specified index.
   * @param {number} index Index.
   * @return {Polygon} Polygon.
   * @api
   */


  MultiPolygon.prototype.getPolygon = function (index) {
    if (index < 0 || this.endss_.length <= index) {
      return null;
    }

    var offset;

    if (index === 0) {
      offset = 0;
    } else {
      var prevEnds = this.endss_[index - 1];
      offset = prevEnds[prevEnds.length - 1];
    }

    var ends = this.endss_[index].slice();
    var end = ends[ends.length - 1];

    if (offset !== 0) {
      for (var i = 0, ii = ends.length; i < ii; ++i) {
        ends[i] -= offset;
      }
    }

    return new _Polygon["default"](this.flatCoordinates.slice(offset, end), this.layout, ends);
  };
  /**
   * Return the polygons of this multipolygon.
   * @return {Array<Polygon>} Polygons.
   * @api
   */


  MultiPolygon.prototype.getPolygons = function () {
    var layout = this.layout;
    var flatCoordinates = this.flatCoordinates;
    var endss = this.endss_;
    var polygons = [];
    var offset = 0;

    for (var i = 0, ii = endss.length; i < ii; ++i) {
      var ends = endss[i].slice();
      var end = ends[ends.length - 1];

      if (offset !== 0) {
        for (var j = 0, jj = ends.length; j < jj; ++j) {
          ends[j] -= offset;
        }
      }

      var polygon = new _Polygon["default"](flatCoordinates.slice(offset, end), layout, ends);
      polygons.push(polygon);
      offset = end;
    }

    return polygons;
  };
  /**
   * Get the type of this geometry.
   * @return {import("./GeometryType.js").default} Geometry type.
   * @api
   */


  MultiPolygon.prototype.getType = function () {
    return _GeometryType["default"].MULTI_POLYGON;
  };
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */


  MultiPolygon.prototype.intersectsExtent = function (extent) {
    return (0, _intersectsextent.intersectsLinearRingMultiArray)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, extent);
  };
  /**
   * Set the coordinates of the multipolygon.
   * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
   * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
   * @api
   */


  MultiPolygon.prototype.setCoordinates = function (coordinates, opt_layout) {
    this.setLayout(opt_layout, coordinates, 3);

    if (!this.flatCoordinates) {
      this.flatCoordinates = [];
    }

    var endss = (0, _deflate.deflateMultiCoordinatesArray)(this.flatCoordinates, 0, coordinates, this.stride, this.endss_);

    if (endss.length === 0) {
      this.flatCoordinates.length = 0;
    } else {
      var lastEnds = endss[endss.length - 1];
      this.flatCoordinates.length = lastEnds.length === 0 ? 0 : lastEnds[lastEnds.length - 1];
    }

    this.changed();
  };

  return MultiPolygon;
}(_SimpleGeometry["default"]);

var _default = MultiPolygon;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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